import { Image, StyleSheet } from "react-native";
import { memo } from "react";
import { avatarSize } from "@/helper/Sizes";
import isEqual from "lodash/isEqual";
import { ThemeView } from "@/components/Theme";

const ListItemImage = (props) => {
    const {
        item = {},
        forceImage = false,
        size = 'sm',
        style = {}
    } = props;
    
    const {
        image:url = null,
        title = null,
        color = null
    } = item;

    if (!url && !forceImage)
        return <></>;

    if (url?.protptype?.isReactComponent || !forceImage)
        return url;

    const _size = avatarSize(size);

    

    return (
        <ThemeView light={color ?? 'trueGray.200'} dark={color ?? 'trueGray.800'} style={[{width: _size, height: _size}, styles.image, style]}>
            <Image source={{uri: url}} style={[{width: _size, height: _size}, styles.image, style]} />
        </ThemeView>
    );

};

const styles = StyleSheet.create({
    image: {
        borderRadius: 100,
    },
    leftItem: {
        
    },
    rightItem: {
        flex: 1
    }
});

export default memo(ListItemImage, isEqual);